import React, { useEffect, useState } from 'react';
import './kanban.css';

const colunas = [
  { id: 'acesso', titulo: '🟢 Acesso inicial' },
  { id: 'analise', titulo: '🟡 Pré-Análise' },
  { id: 'pix', titulo: '🟠 Gerou Pix' },
  { id: 'criado', titulo: '🔵 Análise Início' },
  { id: 'em_andamento', titulo: '🟣 Em Andamento' },
  { id: 'concluido', titulo: '🟤 Concluído' },
  { id: 'entregue', titulo: '🟩 Entregue' },
];

const KanbanDashboard = () => {
  const [dados, setDados] = useState({});
  const [periodo, setPeriodo] = useState('7d');

  const carregarDados = () => {
    fetch(`https://api.youevolution.com.br/get_kanban_tokens.php?periodo=${periodo}`, {
      headers: { 'X-API-Key': 'UNIVERSOYOU-123456' }
    })
      .then(res => res.json())
      .then(res => {
        if (res && typeof res.kanban === 'object') {
          setDados(res.kanban);
          //console.log(res.kanban);
        } else {
          console.warn("⚠️ Formato de resposta inválido:", res);
          setDados({});
        }
      })
      .catch(err => {
        console.error("❌ Erro ao carregar Kanban:", err);
      });
  };

  const formatarNome = (nomeBruto) => {
    const original = (nomeBruto || '').trim();
    if (!original) return '';
    const partes = original.split(/\s+/);
    if (partes.length <= 2) return partes.join(' ');
    const primeiro = partes[0];
    const ultimo = partes[partes.length - 1];
    const meios = partes.slice(1, -1).map(p => p.charAt(0).toUpperCase()).join(' ');
    return `${primeiro} ${meios} ${ultimo}`;
  };


  useEffect(() => {
    carregarDados();
    const intervalo = setInterval(carregarDados, 10000);
    return () => clearInterval(intervalo);
  }, [periodo]);

  return (
    <div className="kanban-container px-2" style={{ maxHeight: '420px', overflow: 'hidden' }}>
      <div className="d-flex justify-content-end mb-3">
        {['1h', '24h', '7d', '30d', 'all'].map(p => (
          <button
            key={p}
            onClick={() => setPeriodo(p)}
            className={`btn btn-sm mx-1 ${periodo === p ? 'btn-primary' : 'btn-secondary'}`}
          >{p}</button>
        ))}
      </div>

      <div className="row">
        {colunas.map(col => (
          <div key={col.id} className="col-xl-1-7 col-lg-2 col-md-4 col-sm-6 mb-3">
            <div className="bg-dark rounded p-2 shadow-sm border border-secondary h-100 d-flex flex-column">
              <h5 className="font-bold text-light mb-2" style={{ fontSize: '0.9rem' }}>
                {col.titulo} <span className="text-info">({(dados[col.id] || []).length})</span>
              </h5>

              <div
                className="text-xs text-light flex-grow-1"
                style={{ overflowY: 'auto', maxHeight: '320px' }}
              >
                {Array.isArray(dados[col.id]) && dados[col.id].length > 0 ? (
                  dados[col.id].map((item, idx) => {
                    const token = typeof item === 'string' ? item : item.token;
                    const nomeOriginal = item.nome ?? null;

                    const isAcesso = col.id === 'acesso';
                    const retid = item.retid ?? '';

                    // Formata nome limpo para etapas como PIX
                    const nomeLimpo = (col.id === 'pix' && nomeOriginal)
                      ? nomeOriginal.replace(/^Diagnóstico YOU\s*-\s*/i, '').trim()
                      : nomeOriginal;

                    const nomeAbreviado = !isAcesso && nomeLimpo ? formatarNome(nomeLimpo) : null;

                    // Formatação especial para acesso: retid[0:15] - token[-10:]
                    const textoExibido = isAcesso
                      ? `${retid.slice(0, 15)} - ${token.slice(-10)}`
                      : (nomeAbreviado || token);

                    const tooltip = col.id === 'analise'
                      ? `${nomeOriginal || ''}\n${token}\n${retid || ''}`
                      : isAcesso
                        ? `${retid}\n${token}`
                        : (nomeOriginal ? `${nomeOriginal}\n${token}` : token);


                    return (
                      <div
                        key={idx}
                        className="bg-secondary rounded px-2 py-1 mb-1 text-wrap d-flex align-items-center gap-1"
                        title={tooltip}
                      >
                        {col.id === 'analise' && retid && token && (
                          <a
                            href={`https://analise.youevolution.com.br/acesso/${retid}?tla=${token}&reg=admin`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Abrir acesso direto"
                            style={{ textDecoration: 'none', color: '#fff' }}
                          >
                            🔗
                          </a>
                        )}
                        {textoExibido}
                      </div>

                    );
                  })
                ) : (
                  <p className="text-muted">Nenhum token</p>
                )}






              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KanbanDashboard;
